import type { LoyaltyActivityCode } from '@models/loyalty.interface';
import { fieldTypes } from '@constants/constant';
import type { Button, Field } from '@modules/dynamic-form-builder/model/formBuilderInterface';

export const LOYALTY_ACTIVITY_CODE_ORDER: LoyaltyActivityCode[] = [
  'FAN_LOGIN',
  'COMMENT_FEED',
  'COMMENT_CHAT',
  'ENGAGE_CONTENT',
  'SHARE_CONTENT',
  'FAN_RECRUITMENT',
  'SUPPORT_CREATOR'
];

export const LOYALTY_ACTIVITY_DEFAULT_POINTS: Record<LoyaltyActivityCode, number> = {
  FAN_LOGIN: 1,
  COMMENT_FEED: 1,
  COMMENT_CHAT: 1,
  ENGAGE_CONTENT: 1,
  SHARE_CONTENT: 1,
  FAN_RECRUITMENT: 3,
  SUPPORT_CREATOR: 1
} as const;

export const LOYALTY_TEXT = {
  PREFERENCES_TITLE: 'Loyalty Points',
  FAN_OF_THE_WEEK: 'Fan of the Week',
  ENABLE: 'Enable',
  DISABLE: 'Disable',
  CANCEL: 'CANCEL',
  ACTIVITY_TO_EARN_POINTS: 'Activity to Earn Points',
  POINTS_EARNED: 'Points Earned',
  STATUS: 'Status',
  POINT: 'Point',
  POINTS: 'Points',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  DISABLED: 'Disabled',
  DISCARD: 'DISCARD',
  SAVE_CHANGES: 'SAVE CHANGES',
  PLACEHOLDER_POINTS: '0',
  MOST_LOYAL_FANS_HEADING: 'Most Loyal Fans',
  NO_LOYALTY_LEADERS: 'There are no Leaders yet.',
  POINTS_REQUIRED_FOR_ACTIVE: 'Points must be greater than 0 before setting this activity as active.',
  ATLEAST_ONE_REQUIRED_FOR_ACTIVE: 'To Enable Loyalty Point Gamification, you must enable at least one Earning Activity below.',
  POINTS_INTEGER_ONLY: 'Points must be a valid integer.',
  POINTS_NON_NEGATIVE: 'Points must be 0 or greater.',
  POINTS_REQUIRED: 'Points are required.',
  PROCEED_ANYWAY: 'PROCEED ANYWAY',
  POINTS_EDIT_WARNING:
    'It is not recommended to change the default values for Earning Points as it could devalue the points that are purchased by fans.',
  LOYALTY_INFO: 'Configure how many loyalty points fans earn from each activity and toggle each rule on or off.',
  LOYALTY_STATUS_INFO: 'Enable loyalty points to start tracking and awarding configured activities.',
  DISPLAY_MY_LEADERBOARD_TO_OTHER_USERS: 'Display Leaderboard'
} as const;

export const LOYALTY_ACTIVITY_LABELS: Record<LoyaltyActivityCode, string> = {
  FAN_LOGIN: 'Logging in Per Day',
  COMMENT_FEED: 'Commenting on a Feed Post (Limit 1 per post)',
  COMMENT_CHAT: 'Commenting in the Chat Room (Limit 1 per day)',
  ENGAGE_CONTENT: 'Watching or Listening to Video, Podcast or Music Portfolio Content (Limit 1 per Item)',
  SHARE_CONTENT: 'Sharing a Piece of Content (Limit 1 per Content Item)',
  FAN_RECRUITMENT: 'Recruiting a New Fan Registration',
  SUPPORT_CREATOR: 'Spending Money (Points Per Dollar Spent)'
};

export const LOYALTY_ENDPOINT_ACTIONS = {
  UPDATE: 'update',
  GET: 'get',
  ENABLE: 'enable',
  DISABLE: 'disable',
  GET_CONFIG: 'get-config'
} as const;

export const LOYALTY_VALIDATION = {
  INTEGER_PATTERN: /^\d+$/,
  NON_NEGATIVE_INTEGER_PATTERN: /^(0|[1-9]\d*)$/
};

export const LOYALTY_DISCARD_BUTTON: Button = {
  type: 'button',
  label: LOYALTY_TEXT.DISCARD,
  name: 'discard',
  class: 'btn btn-discard'
};

export const LOYALTY_SAVE_CHANGES_BUTTON_BASE: Button = {
  type: 'button',
  label: LOYALTY_TEXT.SAVE_CHANGES,
  name: 'saveChanges',
  class: 'btn btn-primary'
};

export const LOYALTY_POINTS_FIELD_BASE: Field = {
  type: fieldTypes.NUMBER,
  name: 'points_earned',
  class: '',
  label: '',
  placeholder: LOYALTY_TEXT.PLACEHOLDER_POINTS,
  validation: {
    required: { message: LOYALTY_TEXT.POINTS_REQUIRED },
    min: { value: 0, message: LOYALTY_TEXT.POINTS_NON_NEGATIVE },
    pattern: {
      value: LOYALTY_VALIDATION.NON_NEGATIVE_INTEGER_PATTERN,
      message: LOYALTY_TEXT.POINTS_INTEGER_ONLY
    }
  }
};

export const LOYALTY_ACTIVE_STATES = {
  true: LOYALTY_TEXT.ACTIVE,
  false: LOYALTY_TEXT.INACTIVE
} as const;

export const LOYALTY_LEADERBOARD_TAB_ID = {
  TOP_SUPPORTER: '1',
  MOST_ENGAGED: '2',
  TOP_RECRUITERS: '3',
  MOST_LOYAL_FANS: '4'
} as const;
